export default __webpack_public_path__ + "static/media/laughing.24b2e62b.png";